import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

class ManagedRadioGroup extends React.Component {
  static propTypes = {
    'aria-labelledby': PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    inline: PropTypes.bool,
    inputClassName: PropTypes.string,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any.isRequired
    })).isRequired,
    required: PropTypes.bool,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    onValueChange: PropTypes.func.isRequired
  }

  static defaultProps = {
    inline: true,
  };

  handleChange = (event) => {
    const { value } = event.target;
    this.props.onChange({ [this.props.name]: value }, event);
    this.props.onValueChange(value, event);
  }

  render() {
    return (
      <div
        aria-labelledby={this.props['aria-labelledby']}
        className={classNames('d-flex gap-2', this.props.className, { 'flex-column': !this.props.inline })}
        role="radiogroup"
      >
        {this.props.options.map(this.renderOption)}
      </div>
    );
  }

  renderOption = ({ label, value }) => {
    const id = `${this.props.name}-${value}`;
    const checked = this.props.value === value;

    return (
      <div className="d-flex" key={value}>
        <input
          checked={checked}
          className={classNames('form-check-input mt-0-5 me-1', this.props.inputClassName)}
          disabled={this.props.disabled}
          id={id}
          name={this.props.name}
          required={this.props.required}
          type="radio"
          value={value}
          onChange={this.handleChange}
        />
        <label htmlFor={id}>{label || value}</label>
      </div>
    );
  }
}

export default ManagedRadioGroup;
